import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faStore,
  faBoxOpen,
  faTruck,
  faUsers,
  faIndustry,
} from "@fortawesome/free-solid-svg-icons";

export default function EduWholesaleHome() {
  const [searchTerm, setSearchTerm] = useState("");

  const categories = [
    { name: "Electronics", icon: faBoxOpen },
    { name: "Clothing", icon: faUsers },
    { name: "Groceries", icon: faTruck },
    { name: "Home & Living", icon: faStore },
    { name: "Industrial", icon: faIndustry },
    { name: "Health & Beauty", icon: faUsers },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-950 to-blue-900 text-white">
      {/* Header */}
      <header className="p-6 flex justify-between items-center bg-blue-950 shadow-lg">
        <h1 className="text-xl font-bold text-yellow-400">ThinkWholesale</h1>
        <nav className="space-x-6 text-lg">
          <a href="#" className="hover:text-yellow-400">Home</a>
          <a href="#" className="hover:text-yellow-400">Categories</a>
          <a href="#" className="hover:text-yellow-400">Deals</a>
          <a href="#" className="hover:text-yellow-400">About</a>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="text-center py-4 px-4 bg-blue-900">
        <h2 className="text-xl lg:text-2xl font-bold text-yellow-300 mb-6">
          India’s Trusted Wholesale Marketplace
        </h2>
        <p className="max-w-m mx-auto text-gray-300 mb-6">
          Connect with verified suppliers and buy in bulk at the best prices.
        </p>

        {/* Search Bar */}
        <div className="flex justify-center max-w-2xl mx-auto">
          <input
            type="text"
            placeholder="Search products, categories, suppliers..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full h-10 px-4 py-3 rounded-l-xl text-gray-900"
          />
          <button className="bg-yellow-400 px-6 rounded-r-xl text-black font-semibold flex items-center gap-2 h-10 w-40">
            <FontAwesomeIcon icon={faSearch} /> Search
          </button>
        </div>
      </section>

      {/* Categories */}
      <section className="py-4 px-6">
        <h3 className="text-2xl font-bold mb-6 text-center text-yellow-400">
          Shop by Category
        </h3>
        <div className="grid grid-cols-2 lg:grid-cols-6 gap-6 text-center">
          {categories.map((cat, index) => (
            <div
              key={index}
              className="bg-blue-800 hover:bg-blue-700 transition rounded-xl p-6 shadow-md flex flex-col items-center cursor-pointer"
            >
              <FontAwesomeIcon
                icon={cat.icon}
                className="text-3xl text-yellow-300 mb-3"
              />
              <p className="font-semibold">{cat.name}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Featured Deals */}
      <section className="py-4 px-6 bg-blue-950">
        <h3 className="text-2xl font-bold mb-6 text-center text-yellow-400">
          Featured Deals
        </h3>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {[1, 2, 3].map((deal) => (
            <div
              key={deal}
              className="bg-blue-800 hover:bg-blue-700 transition rounded-xl p-6 shadow-md"
            >
              <h4 className="text-lg font-semibold mb-3">Deal {deal}</h4>
              <p className="text-gray-300">
                Special bulk pricing available. Save up to 40% on wholesale orders.
              </p>
              <button className="mt-4 bg-yellow-400 text-black px-4 py-2 rounded-lg font-semibold hover:bg-yellow-500">
                View Deal
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-4 px-6 text-center">
        <h3 className="text-2xl font-bold mb-4">Grow Your Business with Us</h3>
        <p className="text-gray-300 mb-6">
          Whether you are a buyer or a seller, ThinkWholesale helps you scale.
        </p>
        <div className="flex justify-center gap-6">
          <button className="bg-yellow-400 text-black px-6 py-3 rounded-lg font-semibold hover:bg-yellow-500">
            Sell on ThinkWholesale
          </button>
          <button className="bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-600">
            Join as Buyer
          </button>
        </div>
      </section>

      <footer className="py-6 bg-blue-950 text-center text-gray-400">
        © {new Date().getFullYear()} ThinkWholesale. All rights reserved.
      </footer>
    </div>
  );
}
